import React from 'react';
import PropTypes from 'prop-types';
import { asModal } from './index';

export const AsModalWithContext = ({ Context, children }) => {
  return (
    <Context.Consumer>
      {(ctx) => {
        const providedChildren = (props) => (
          <Context.Provider value={ctx}>{React.cloneElement(React.Children.only(children), props)}</Context.Provider>
        );
        const ChildrenAsModal = asModal(providedChildren);
        return <ChildrenAsModal />;
      }}
    </Context.Consumer>
  );
};

AsModalWithContext.propTypes = {
  Context: PropTypes.any.isRequired,
  children: PropTypes.node.isRequired,
};
